import { render, staticRenderFns } from "./UbahPassword.vue?vue&type=template&id=31c2fa82&"
import script from "./UbahPassword.vue?vue&type=script&lang=js&"
export * from "./UbahPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports